module.exports = __webpack_public_path__ + "static/media/image-1200.ece046d3.jpg";